/* Scroll-driven timeline.
 *
 * The section renders with .lum-tl--static, which CSS styles as "every step
 * finished". That is the no-JS and reduced-motion state, so the content never
 * depends on this file running. If we get here and motion is allowed, we drop
 * the static class and let an IntersectionObserver light each step instead.
 */
(function () {
  if (window.lumTimelineReady) return;
  window.lumTimelineReady = true;

  function boot() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-lum-timeline]').forEach(function (tl) {
      if (tl.dataset.lumBound === '1') return;
      tl.dataset.lumBound = '1';

      var steps = Array.prototype.slice.call(tl.querySelectorAll('[data-lum-step]'));
      if (!steps.length) return;

      if (reduce || !('IntersectionObserver' in window)) return; // keep the static state

      tl.classList.remove('lum-tl--static');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-active');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -22% 0px', threshold: 0.25 });

      steps.forEach(function (s) { io.observe(s); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
